import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef } from "react";
import classnames from "classnames";
import { InfiniteScroll } from "../../InfiniteScroll/index.js";
import { CircularProgress } from "../../CircularProgress/index.js";
import { Box } from "../../Box/index.js";
import ListBox_styles from "./ListBox.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ListBox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ListBox_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const ListBox = /*#__PURE__*/ forwardRef((t0, ref)=>{
    const $ = c(29);
    let children;
    let dataLength;
    let hasMore;
    let loading;
    let next;
    let rest;
    let t1;
    if ($[0] !== t0) {
        ({ hasMore, dataLength, next, loading, long: t1, children } = t0), rest = _object_without_properties(t0, [
            "hasMore",
            "dataLength",
            "next",
            "loading",
            "long",
            "children"
        ]);
        $[0] = t0;
        $[1] = children;
        $[2] = dataLength;
        $[3] = hasMore;
        $[4] = loading;
        $[5] = next;
        $[6] = rest;
        $[7] = t1;
    } else {
        children = $[1];
        dataLength = $[2];
        hasMore = $[3];
        loading = $[4];
        next = $[5];
        rest = $[6];
        t1 = $[7];
    }
    const long = void 0 === t1 ? false : t1;
    const { classes } = ListBox_styles();
    let t2;
    if ($[8] !== classes.longScrollableWrapper || $[9] !== classes.scrollableWrapper || $[10] !== long) {
        t2 = classnames(classes.scrollableWrapper, {
            [classes.longScrollableWrapper]: long
        });
        $[8] = classes.longScrollableWrapper;
        $[9] = classes.scrollableWrapper;
        $[10] = long;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== loading) {
        t3 = loading && /*#__PURE__*/ jsx(Box, {
            display: "flex",
            justifyContent: "center",
            p: "16",
            children: /*#__PURE__*/ jsx(CircularProgress, {
                size: 30
            })
        });
        $[12] = loading;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsx("div", {});
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== children || $[16] !== classes.listBox) {
        t5 = /*#__PURE__*/ jsx("ul", {
            className: classes.listBox,
            children: children
        });
        $[15] = children;
        $[16] = classes.listBox;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== dataLength || $[19] !== hasMore || $[20] !== next || $[21] !== t3 || $[22] !== t5) {
        t6 = /*#__PURE__*/ jsx(InfiniteScroll, {
            next: next,
            hasMore: hasMore,
            dataLength: dataLength,
            loader: t3,
            endMessage: t4,
            scrollId: "multiple-suggested-input-scrollable",
            children: t5
        });
        $[18] = dataLength;
        $[19] = hasMore;
        $[20] = next;
        $[21] = t3;
        $[22] = t5;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== ref || $[25] !== rest || $[26] !== t2 || $[27] !== t6) {
        t7 = /*#__PURE__*/ jsx("div", _object_spread_props(_object_spread({}, rest), {
            id: "multiple-suggested-input-scrollable",
            ref: ref,
            className: t2,
            children: t6
        }));
        $[24] = ref;
        $[25] = rest;
        $[26] = t2;
        $[27] = t6;
        $[28] = t7;
    } else t7 = $[28];
    return t7;
});
export { ListBox };
